export default __webpack_public_path__ + "static/media/arrow-back.00d41b59.svg";